/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../pages/login';
import EmptyLayout from '../../../layouts/empty';
import { RouteNameEnum } from '../../../enums/routeName';

const BaseRoutes: React.FC = () => (
  <Routes>
    <Route element={<EmptyLayout />}>
      <Route path={RouteNameEnum.auth.login} element={<Login />} />
    </Route>
  </Routes>
);

export default BaseRoutes;
